<script setup>
    import storeCardVue from '../components/storeCard.vue'
    import { ref, getCurrentInstance } from 'vue'

    const { proxy } = getCurrentInstance()
    const items = ref([])

    getStore()

    async function getStore() {
        const res = await proxy.$api({serviceName: "store", methodName: "GetProduct"})
        items.value = res
    }
</script>

<template>
    <v-app-bar :elevation="2" class="modern-app-bar">
        <v-icon class="mr-3">mdi-store</v-icon>
        <div class="app-bar-content">
            <v-app-bar-title class="app-bar-main-title">Merch</v-app-bar-title>
            <div class="app-bar-subtitle">Official NightRiderz merchandise</div>
        </div>
        <v-spacer></v-spacer>
        <a href="https://teespring.com/stores/nightriderz" target="_blank">
            <v-btn variant="tonal">
                <v-icon class="mr-2">mdi-open-in-new</v-icon>
                Visit Store
            </v-btn>
        </a>
    </v-app-bar>
    <div class="grid">
        <storeCardVue v-for="item in items" :key="item.id" :data="item"/>        
    </div>
</template>

<style scoped>
    .grid {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    /* Modern App Bar Styles */
    .modern-app-bar {
        padding: 8px 16px !important;
    }

    .app-bar-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 2px;
    }

    .app-bar-main-title {
        font-size: 1.4rem !important;
        font-weight: 600 !important;
        line-height: 1.2 !important;
    }

    .app-bar-subtitle {
        font-size: 0.85rem;
        color: rgba(255, 255, 255, 0.7);
        line-height: 1;
    }
</style>